"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorBar = exports.getColorRange = exports.ColorRanges = void 0;

var _react = _interopRequireDefault(require("react"));

var _colorbrewer = _interopRequireDefault(require("colorbrewer"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _lodash = _interopRequireDefault(require("lodash.get"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  > *:first-child {\n    border-top-left-radius: 0.25rem;\n    border-bottom-left-radius: 0.25rem;\n  }\n  > *:last-child {\n    border-top-right-radius: 0.25rem;\n    border-bottom-right-radius: 0.25rem;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ColorRanges = {};
exports.ColorRanges = ColorRanges;

var _loop = function _loop(type) {
  _colorbrewer["default"].schemeGroups[type].forEach(function (name) {
    var group = _colorbrewer["default"][name];

    for (var length in group) {
      if (!(length in ColorRanges)) {
        ColorRanges[length] = [];
      }

      ColorRanges[length].push({
        type: "".concat(type[0].toUpperCase()).concat(type.slice(1)),
        name: name,
        category: "Colorbrewer",
        colors: group[length]
      });
    }
  });
};

for (var type in _colorbrewer["default"].schemeGroups) {
  _loop(type);
}

console.log("ColorRanges", ColorRanges);

var getColorRange = function getColorRange(size, name) {
  return (0, _lodash["default"])(ColorRanges, [size], []).reduce(function (a, c) {
    return c.name === name ? c.colors : a;
  }, []).slice();
};

exports.getColorRange = getColorRange;

var ColorBarContainer = _styledComponents["default"].div(_templateObject());

var ColorBar = function ColorBar(_ref) {
  var colors = _ref.colors,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 3 : _ref$size;
  return /*#__PURE__*/_react["default"].createElement(ColorBarContainer, {
    className: "grid grid-cols-".concat(colors.length)
  }, colors.map(function (c, i) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: i,
      style: {
        backgroundColor: c,
        transition: "background-color 0.5s"
      },
      className: "col-span-1 h-".concat(size)
    });
  }));
};

exports.ColorBar = ColorBar;